import { X } from "lucide-react";
import { cn } from "@repo/utils";
import { Button, type ButtonProps } from "../button.js";

type Props = Omit<ButtonProps, "icon" | "size" | "variant" | "children"> & {
  label?: string;
};

export const ClearButton = ({ label = "Clear", className, ...props }: Props) => (
  <Button
    type="button"
    icon={<X size={14} />}
    size="icon_sm"
    variant="ghost"
    aria-label={label}
    title={label}
    className={cn("text-gray-500", className)}
    {...props}
  />
);
